
// // App.jsx

// import React from "react";
// import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
// import { useAuth } from "./context/AuthContext";

// // Componentes base
// import Header from "./components/Header";
// import Sidebar from "./components/Sidebar";
// import Login from "./components/Login";
// import Unauthorized from "./components/Unauthorized";

// // Dashboards y perfiles
// // import Dashboard from "./pages/Dashboard";
// import PerfilEstudiante from "./components/estudiante/PerfilEstudiante";
// import ProfesorPerfil from "./Profesor/PerfilProfesor";
// import RectorPerfil from "./components/rector/RectorPerfil";
// import PadrePerfil from "./components/Padre/PadrePerfil";

// // ================== RECTOR ==================
// import CreateUser from "./components/rector/CreateUser";
// import MatriculaForm from "./components/rector/MatriculaForm";
// import EnviarComunicado from "./components/rector/EnviarComunicado";
// import AsignarMaterias from "./components/rector/AsignarMarteria";
// import AgregarMateria from "./components/rector/AgregarMateria";
// import AsignarProfesoresGrupo from "./components/rector/AsignarProfesoresGrupo";
// import RectorHorario from "./components/rector/CrearHorarioRector";
// import ConfiguracionNotas from "./components/rector/ConfiguracionNotas";
// import CronogramaPeriodos from "./components/rector/CronogramaPeriodos";
// import AuditoriaCompleta from "./components/rector/Auditoria";
// // import GestionAcademica from "./components/rector/GestionAcademica";
// import Publicaciones from "./components/rector/Publicaciones";
// import ExcusasRector from "./components/Excusas/RectorExcusaList";
// import HorarioEstudianteAdmin from "./components/rector/HorarioEstudianteAdmin";
// import ModuloExpulsiones from "./components/rector/ModuloExpulsiones";
// import ManualAdmin from "./components/rector/ManualAdmin";
// import DashboardRector from "./components/rector/RectorDashboard";
// import RectorDirectorDeGrupo from "./components/rector/RectorDirectorDeGrupo";
// import ModuloComportamiento from "./components/rector/ModuloComportamiento";
// import HorasRector from "./components/rector/HorasRector";
// import Sedes from "./components/rector/Sedes";
// import BoletinesMasivo from "./components/rector/BoletinesMasivo";
// import LogosInstituciones from "./components/rector/LogosInstituciones";
// import ResultadosEleccion from "./components/ResultadosEleccion";
// import EleccionesRector from "./components/rector/EleccionesRector";
// import InformesRector from "./components/rector/InformesRector";

// // ================== PROFESOR ==================
// import MisAsignaciones from "./Profesor/MisAsignaciones";
// import ListaEstudiantes from "./Profesor/ListaEstudiantes";
// import TareasProfesor from "./Profesor/TareasProfesor";
// import EvaluacionesClase from "./Profesor/EvaluacionesClase";
// import AsistenciaProfesor from "./Profesor/AsistenciaProfesor";
// import HorarioProfesor from "./Profesor/HorarioProfesor";
// import NotasProfesor from './Profesor/ModuloNotas';
// import DashboardProfesor from "./Profesor/DashboardProfesor";
// import ContenidosProfesor  from "./Profesor/GestionContenido";
// import ModuloPlaneacion from "./Profesor/PlaneacionPage";
// import CalificacionesProfesor from "./Profesor/ModuloCalificar";
// import ExcusasProfesor from "./components/Excusas/ProfesorExcusaList";
// // import NotasFinalesDocente from "./Profesor/ModuloNotasFinales";
// import DirectorGrupoProfesor from "./Profesor/DirectorGrupoProfesor";
// import ModuloDisciplina from "./Profesor/ModuloDisciplina";
// import HorasSocialesProfesor from "./Profesor/HorasProfesor";
// import BoletinesProfesor from "./components/Padre/BoletinesProfesor";
// import ProfesorRecuperaciones from "./Profesor/ProfesorRecuperaciones";

// // ================== ESTUDIANTE / PADRE ==================
// import TareasEstudiante from "./components/estudiante/TareasEstudiante";
// import MisAsignacione from "./components/estudiante/MisAsignaciones";
// import MisCalificaciones from "./components/estudiante/MisCalificaciones";
// import TareasPadre from "./components/Padre/TareasPadre";
// import ExcusaForm from "./components/Excusas/ExcusasEstudiante";
// // import ExcusasProfesor from "./components/Excusas/EstudianteExcusaList";
// import VerContenido from "./components/estudiante/VerContenido";
// import HorarioEstudiante from "./components/estudiante/HorarioEstudiante";
// import ContenidosEstudiante from "./components/estudiante/ContenidosEstudiante";
// import ManualViewer from "./Profesor/ManualViewer";
// import ModuloNotasFinales from "./Profesor/ModuloNotasFinales";
// import HorasSocialesEstudiante from "./components/estudiante/HorasSocialesEstudiante";
// import HorasSocialesRector from "./components/rector/HorasSocialesRector";
// import MiBoletin from "./components/estudiante/MiBoletin";
// import EleccionesEstudiante from "./components/estudiante/EleccionesEstudiante";
// import DashboardPadre from "./components/Padre/DashboardPadre";
// import PadreRendimiento from "./components/Padre/PadreRendimiento";
// import PadreExcusas from "./components/Padre/PadreExcusas";
// import PadreNotas from "./components/Padre/PadreNotas";
// import PadreAsistencia from "./components/Padre/PadreAsistencia";
// import BoletinPadre from "./components/Padre/BoletinPadre";


// // secretaria
// import DashboardSecretaria from "./components/secretaria/DashboardSecretaria";

// import SecretariaBuscarEstudiantes from "./components/secretaria/SecretariaBuscarEstudiantes";
// import Certificaciones from "./components/secretaria/Certificaciones";
// import VerificarCertificado from "./components/secretaria/VerificarCertificado";
// import Informes from "./components/secretaria/Informes";
// import GestionDocumentos from "./components/secretaria/GestionDocumentos";


// // desarrollador 

// import CrearInstitucion from "./admin/CrearInstitucion";
// import DevDashboard from "./admin/DevDashboard";

// // ================== Wrappers dinámicos ==================
// function GestionContenidoWrapper() {
//   const { asignaturaId } = useParams();
//   return <ContenidosProfesor asignaturaId={asignaturaId} />;
// }

// function ModuloPlaneacionWrapper() {
//   const { asignaturaId } = useParams();
//   return <ModuloPlaneacion asignaturaId={asignaturaId} />;
// }

// // ================== RUTA PRIVADA ==================
// function PrivateRoute({ allowedRoles, element }) {
//   const { user } = useAuth();
//   if (!user) return <Navigate to="/login" replace />;
//   if (!allowedRoles.includes(user.role)) return <Navigate to="/unauthorized" replace />;
//   return element;
// }

// // ================== CONTENIDO PRINCIPAL ==================
// function AppContent() {
//   const location = useLocation();
//   const { user } = useAuth();
//   const isLoginPage = location.pathname === "/login";

//   return (
//     <>
//       {!isLoginPage && user && <Header />}
//       <div className="layout">
//         {!isLoginPage && user && <Sidebar />}
//         <div className="main-content">
//           <Routes>
//             <Route path="/" element={<Navigate to="/login" replace />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/unauthorized" element={<Unauthorized />} />

//             {/* ================== RECTOR ================== */}
//             <Route
//               path="/dashboard"
//               element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<DashboardRector />} />}
//             />
//             <Route
//               path="/perfil-rector/:id"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<RectorPerfil />} />}
//             />
//             <Route
//               path="/crear-usuario"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<CreateUser />} />}
//             />
//             <Route
//               path="/matricula"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<MatriculaForm />} />}
//             />
//             <Route
//               path="/enviar-comunicado"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<EnviarComunicado />} />}
//             />
//             <Route
//               path="/asignar-materias-profesor"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<AsignarMaterias />} />}
//             />
//             <Route
//               path="/asignar-profesores-grupo"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<AsignarProfesoresGrupo />} />}
//             />
//             <Route
//               path="/agregar-materia"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<AgregarMateria />} />}
//             />
//             <Route
//               path="/excusas-rector"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<ExcusasRector user={user} />} />}
//             />
//             <Route
//               path="/crear-horario"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<RectorHorario />} />}
//             />
//             <Route
//               path="/configuracion-notas"
//               element={<PrivateRoute allowedRoles={["rector", "administrativo"]} element={<ConfiguracionNotas />} />}
//             />
//             {/* <Route
//               path="/gestion-academica"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<GestionAcademica />} />}
//             /> */}
//             <Route
//               path="/cronograma"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<CronogramaPeriodos />} />}
//             />
//             <Route
//               path="/auditoria"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<AuditoriaCompleta />} />}
//             />
//             <Route
//               path="/publicaciones"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<Publicaciones />} />}
//             />
//             <Route
//               path="/horario-estudiante"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<HorarioEstudianteAdmin />} />}
//             />
//                  <Route
//               path="/explusacion"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<ModuloExpulsiones/>} />}
//             />

//                      <Route
//               path="/manual"
//               element={<PrivateRoute allowedRoles={["rector"]} element={<ManualAdmin/>} />}
//             />

//            <Route path="/director-de-grupo" element={<PrivateRoute allowedRoles={["rector"]} element={<RectorDirectorDeGrupo />} />} />
//           <Route 
//   path="/comportamiento" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<ModuloComportamiento />} />} 
// />

//           <Route 
//   path="/sede" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<Sedes />} />} 
// />
//           <Route 
//   path="/horas-social" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<HorasSocialesRector />} />} 
// />

//           <Route 
//   path="/boletines-masivo" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<BoletinesMasivo />} />} 
// />
//           <Route 
//   path="/subir-logo" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<LogosInstituciones />} />} 
// />
//           <Route 
//   path="/elecciones-rector" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<EleccionesRector />} />} 

// />



//           <Route 
//   path="/resultados-eleccion" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<ResultadosEleccion />} />} 

// />

//           <Route 
//   path="/informes-rector" 
//   element={<PrivateRoute allowedRoles={["rector"]} element={<InformesRector/>} />} 
// />
//             {/* ================== ESTUDIANTE ================== */}
//             <Route
//               path="/perfil-estudiante"
//               element={<PrivateRoute allowedRoles={["estudiante"]} element={<PerfilEstudiante />} />}
//             />
//             <Route
//               path="/perfil-estudiante/:id"
//               element={<PrivateRoute allowedRoles={["estudiante"]} element={<PerfilEstudiante />} />}
//             />
//             <Route
//               path="/tareas-estudiante"
//               element={<PrivateRoute allowedRoles={["estudiante"]} element={<TareasEstudiante />} />}
//             />
//             <Route
//               path="/mis-asignaciones-estudiante"
//               element={<PrivateRoute allowedRoles={["estudiante"]} element={<MisAsignacione />} />}
//             />
//             <Route
//               path="/mis-calificaciones"
//               element={<PrivateRoute allowedRoles={["estudiante"]} element={<MisCalificaciones />} />}
//             />
//             <Route
//               path="/excusas-estudiante"
//               element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<ExcusaForm user={user} />} />}
//             />
//             <Route
//               path="/ver-contenido/:asignaturaId"
//               element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<VerContenido />} />}
//             />
//             <Route
//               path="/horario-student"
//               element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<HorarioEstudiante />} />}
//             />

//    <Route
//               path="/guias"
//               element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<ContenidosEstudiante />} />}
//             />

//  <Route path="/manual-convivencia-estudiante" element={<PrivateRoute allowedRoles={["estudiante"]} element={<ManualViewer />} />} />

// <Route
//   path="/horas-sociales"
//   element={
//     <PrivateRoute
//       allowedRoles={["estudiante"]}
//       element={<HorasSocialesEstudiante />}
//     />
//   }
// />


// <Route
//   path="/elecciones-estudiante"
//   element={
//     <PrivateRoute
//       allowedRoles={["estudiante"]}
//       element={<EleccionesEstudiante />}
//     />
//   }
// />


//   <Route path="/my-boletin" element={<PrivateRoute allowedRoles={["estudiante"]} element={<MiBoletin />} />} />

//             {/* ================== PADRE ================== */}
//             <Route
//               path="/perfil-padre/:id"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<PadrePerfil />} />}
//             />

//                  <Route
//               path="/dashboard-padre"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<DashboardPadre />} />}
//             />
//             <Route
//               path="/tareas-padre"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<TareasPadre />} />}
//             />

       
//             <Route
//               path="/rendimiento-padre/:estudianteId"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<PadreRendimiento />} />}
//             />
//                <Route
//               path="/excusas-padre/:estudianteId"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<PadreExcusas />} />}
//             />
//                      <Route
//               path="/notas-padre/:estudianteId"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<PadreNotas />} />}
//             />

   
//                              <Route
//               path="/asistencia-padre/:estudianteId"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<PadreAsistencia />} />}
//             />

//                                        <Route
//               path="/boletin-padre"
//               element={<PrivateRoute allowedRoles={["padre"]} element={<BoletinPadre />} />}
//             />



//             {/* ================== PROFESOR ================== */}
//             <Route
//               path="/perfil-profesor/:id"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<ProfesorPerfil />} />}
//             />
//             <Route
//               path="/mis-asignaciones-profesor"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<MisAsignaciones />} />}
//             />
//             <Route
//               path="/lista-estudiantes"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<ListaEstudiantes />} />}
//             />
//             <Route
//               path="/tareas-profesor"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<TareasProfesor />} />}
//             />
//             <Route
//               path="/evaluaciones-clase"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<EvaluacionesClase />} />}
//             />
//             <Route
//               path="/asistencias-profesor"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<AsistenciaProfesor />} />}
//             />
//             <Route
//               path="/excusas-profesor"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<ExcusasProfesor user={user?.id} />} />}
//             />
//             <Route
//               path="/mi-horario"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<HorarioProfesor profesorId={user?.id} />} />}
//             />
//             <Route
//               path="/notas"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<CalificacionesProfesor profesorId={user?.id} />} />}
//             />
//             <Route
//               path="/planeacion/:asignaturaId"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloPlaneacionWrapper />} />}
//             />
//             <Route
//               path="/gestion-contenido/:asignaturaId"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<GestionContenidoWrapper />} />}
//             />
//             <Route
//               path="/dashboard-profesor"
//               element={<PrivateRoute allowedRoles={["profesor"]} element={<DashboardProfesor />} />}
//             />
//         <Route path="/notas-finales" element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloNotasFinales profesor_id={user?.id} />
// } />} />
//             <Route path="/manual-convivencia-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<ManualViewer />} />} />
//              <Route path="/direccion-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<DirectorGrupoProfesor />} />} />
//       {/* <Route path="/diciplina" element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloDisciplina />} />} /> */}
//            <Route path="/horas-sociales-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<HorasSocialesProfesor />} />} />
//             <Route path="/boletin" element={<PrivateRoute allowedRoles={["profesor"]} element={<BoletinesProfesor />} />} />

//             <Route path="/recuperaciones-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<ProfesorRecuperaciones />} />} />

//            {/* desarrollador */}

//               {/* ================== DESARROLLADOR ================== */}
// <Route
//   path="/crear-institucion"
//   element={
//     <PrivateRoute
//       allowedRoles={["desarrollador"]}
//       element={<CrearInstitucion />}
//     />
//   }
// />
// <Route
//   path="/dev-dashboard"
//   element={
//     <PrivateRoute
//       allowedRoles={["desarrollador"]}
//       element={<DevDashboard />}
//     />
//   }
// />


// {/* secretaria */}

// <Route
//   path="/dashboard-secretaria"
//   element={
//     <PrivateRoute
//       allowedRoles={["secretaria"]}
//       element={<DashboardSecretaria />}
//     />
//   }
// />

// <Route
//   path="/secretaria/estudiantes"
//   element={
//     <PrivateRoute
//       allowedRoles={["secretaria", "rector", "coordinador"]}
//       element={<SecretariaBuscarEstudiantes />}
//     />
//   }
// />

// <Route path="/secretaria/certificaciones" element={<Certificaciones />} />

// <Route
//   path="/verificar-certificado/:codigo"
//   element={<VerificarCertificado />}
// />

// <Route path="/matriculasecretaria" element={<MatriculaForm />} />
// <Route path="/informes" element={<Informes />} />
// <Route path="/documentos" element={<GestionDocumentos/>} />



//           </Routes>
//         </div>
//       </div>
//     </>
//   );
// }

// export default function App() {
//   return <AppContent />;
// }


//


// App.jsx

import React from "react";
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

// Componentes base
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Login from "./components/Login";
import Unauthorized from "./components/Unauthorized";

// Dashboards y perfiles
// import Dashboard from "./pages/Dashboard";
import PerfilEstudiante from "./components/estudiante/PerfilEstudiante";
import ProfesorPerfil from "./Profesor/PerfilProfesor";
import RectorPerfil from "./components/rector/RectorPerfil";
import PadrePerfil from "./components/Padre/PadrePerfil";

// ================== RECTOR ==================
import CreateUser from "./components/rector/CreateUser";
import MatriculaForm from "./components/rector/MatriculaForm";
import EnviarComunicado from "./components/rector/EnviarComunicado";
import AsignarMaterias from "./components/rector/AsignarMarteria";
import AgregarMateria from "./components/rector/AgregarMateria";
import AsignarProfesoresGrupo from "./components/rector/AsignarProfesoresGrupo";
import RectorHorario from "./components/rector/CrearHorarioRector";
import ConfiguracionNotas from "./components/rector/ConfiguracionNotas";
import CronogramaPeriodos from "./components/rector/CronogramaPeriodos";
// import AuditoriaCompleta from "./components/rector/Auditoria";
// import GestionAcademica from "./components/rector/GestionAcademica";
import Publicaciones from "./components/rector/Publicaciones";
import ExcusasRector from "./components/Excusas/RectorExcusaList";
import HorarioEstudianteAdmin from "./components/rector/HorarioEstudianteAdmin";
import ModuloExpulsiones from "./components/rector/ModuloExpulsiones";
import ManualAdmin from "./components/rector/ManualAdmin";
import DashboardRector from "./components/rector/RectorDashboard";
import DirectorGrupo from './components/rector/RectorDirectorDeGrupo'
import ModuloComportamiento from "./components/rector/ModuloComportamiento";
import HorasRector from "./components/rector/HorasRector";
import Sedes from "./components/rector/Sedes";
import BoletinesMasivo from "./components/rector/BoletinesMasivo";
import LogosInstituciones from "./components/rector/LogosInstituciones";
import ResultadosEleccion from "./components/ResultadosEleccion";
import EleccionesRector from "./components/rector/EleccionesRector";
import InformesRector from "./components/rector/InformesRector";
import RectorEleccionesPro from "./components/rector/EleccionesRector";
import FichaSeguimientoRevision from "./components/rector/FichaSeguimientoRevision";
import FotoPerfilEstudiante from "./components/FotoPerfilEstudiante";
import Auditoria from './components/Auditoria/Auditoria';
import RectorSimulacros from "./components/rector/RectorSimulacros";
import  RectorAnaliticaSimulacro from "./components/rector/RectorAnaliticaSimulacro";
import RectorPlaneaciones from "./components/rector/RectorPlaneaciones";
import MatriculaMasiva from "./components/rector/MatriculaMasiva";
import AutoevaluacionGestion from "./components/rector/AutoevaluacionGestion";


// ================== PROFESOR ==================
import MisAsignaciones from "./Profesor/MisAsignaciones";
import ListaEstudiantes from "./Profesor/ListaEstudiantes";
import TareasProfesor from "./Profesor/TareasProfesor";
import EvaluacionesClase from "./Profesor/EvaluacionesClase";
import AsistenciaProfesor from "./Profesor/AsistenciaProfesor";
import HorarioProfesor from "./Profesor/HorarioProfesor";
import NotasProfesor from './Profesor/ModuloNotas';
import DashboardProfesor from "./Profesor/DashboardProfesor";
import ContenidosProfesor  from "./Profesor/GestionContenido";
import ModuloPlaneacion from "./Profesor/PlaneacionPage";
import CalificacionesProfesor from "./Profesor/ModuloCalificar";
import ExcusasProfesor from "./components/Excusas/ProfesorExcusaList";
// import NotasFinalesDocente from "./Profesor/ModuloNotasFinales";
import DirectorGrupoProfesor from "./Profesor/DirectorGrupoProfesor";
import ModuloDisciplina from "./Profesor/ModuloDisciplina";
import HorasSocialesProfesor from "./Profesor/HorasProfesor";
import BoletinesProfesor from "./components/Padre/BoletinesProfesor";
import ProfesorRecuperaciones from "./Profesor/ProfesorRecuperaciones";
import PendientesDocente from "./Profesor/PendientesDocente";
import Observaciones from "./Profesor/Observaciones";
import FichaSeguimiento from "./Profesor/FichaSeguimiento";
import BoletinProfesor from "./Profesor/BoletinProfesor";
import HojaVidaEstudiante from "./components/rector/HojaVidaEstudiante";
import HojaVidaEstudianteProfesor  from "./Profesor/HojaVidaEstudianteProfesor";
import ProfesorSimulacros from './Profesor/ProfesorSimulacros';
import EleccionesVotacion from './votacion/EleccionesVotacion';
import ProfesorPlaneaciones from "./Profesor/ProfesorPlaneaciones";
import AutoevaluacionResponder from "./components/Autoevaluacion/AutoevaluacionResponder";

// ================== ESTUDIANTE / PADRE ==================
import TareasEstudiante from "./components/estudiante/TareasEstudiante";
import MisAsignacione from "./components/estudiante/MisAsignaciones";
import MisNotasEstudiante from "./components/estudiante/MisCalificaciones";
import TareasPadre from "./components/Padre/TareasPadre";
import ExcusaForm from "./components/Excusas/ExcusasEstudiante";
// import ExcusasProfesor from "./components/Excusas/EstudianteExcusaList";
import VerContenido from "./components/estudiante/VerContenido";
import HorarioEstudiante from "./components/estudiante/HorarioEstudiante";
import ContenidosEstudiante from "./components/estudiante/ContenidosEstudiante";
import ManualViewer from "./Profesor/ManualViewer";
import ModuloNotasFinales from "./Profesor/ModuloNotasFinales";
import HorasSocialesEstudiante from "./components/estudiante/HorasSocialesEstudiante";
import HorasSocialesRector from "./components/rector/HorasSocialesRector";
import MiBoletin from "./components/estudiante/MiBoletin";
import EleccionesEstudiante from "./components/estudiante/EleccionesEstudiante";
import DashboardPadre from "./components/Padre/DashboardPadre";
import PadreRendimiento from "./components/Padre/PadreRendimiento";
import PadreExcusas from "./components/Padre/PadreExcusas";
import PadreNotas from "./components/Padre/PadreNotas";
import PadreAsistencia from "./components/Padre/PadreAsistencia";
import BoletinPadre from "./components/Padre/BoletinPadre";
import DashboardEstudiante from "./components/EstudianteDashboard";
import  EstudianteSimulacros  from './components/estudiante/EstudianteSimulacros'


// secretaria
import DashboardSecretaria from "./components/secretaria/DashboardSecretaria";

import SecretariaBuscarEstudiantes from "./components/secretaria/SecretariaBuscarEstudiantes";
import Certificados from "./components/secretaria/Certificado";
import VerificarCertificado from "./components/secretaria/VerificarCertificado";
import Informes from "./components/secretaria/Informes";
import GestionDocumentos from "./components/secretaria/GestionDocumentos";


// desarrollador 

import CrearInstitucion from "./admin/CrearInstitucion";
import DevDashboard from "./admin/DevDashboard";
import Soporte from "./admin/Soporte";

// ================== Wrappers dinámicos ==================
function GestionContenidoWrapper() {
  const { asignaturaId } = useParams();
  return <ContenidosProfesor asignaturaId={asignaturaId} />;
}

function ModuloPlaneacionWrapper() {
  const { asignaturaId } = useParams();
  return <ModuloPlaneacion asignaturaId={asignaturaId} />;
}

// ================== RUTA PRIVADA ==================
function PrivateRoute({ allowedRoles, element }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!allowedRoles.includes(user.role)) return <Navigate to="/unauthorized" replace />;
  return element;
}

// ================== CONTENIDO PRINCIPAL ==================
function AppContent() {
  const location = useLocation();
  const { user } = useAuth();
  const isLoginPage = location.pathname === "/login";

  return (
    <>
      {!isLoginPage && user && <Header />}
      <div className="layout">
        {!isLoginPage && user && <Sidebar />}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/soporte" element={<Soporte />} />

            {/* ================== RECTOR ================== */}
         

            {/* ================== RECTOR ================== */}
            <Route path="/dashboard-rector" element={<PrivateRoute allowedRoles={["rector"]} element={<DashboardRector />} />} />
            <Route path="/perfil-rector/:id" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorPerfil />} />} />
            <Route path="/crear-usuario" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<CreateUser />} />} />
            <Route path="/matricula" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<MatriculaForm />} />} />
            <Route path="/enviar-comunicado" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<EnviarComunicado />} />} />
            <Route path="/asignar-materias" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<AsignarMaterias />} />} />
            <Route path="/asignar-profesores-grupo" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<AsignarProfesoresGrupo />} />} />
            <Route path="/agregar-materia" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<AgregarMateria />} />} />
            <Route path="/excusas-rector" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<ExcusasRector user={user} />} />} />
            <Route path="/crear-horario" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorHorario />} />} />
            <Route path="/configuracion-notas" element={<PrivateRoute allowedRoles={["rector", "coordinador", "administrativo"]} element={<ConfiguracionNotas />} />} />
            <Route path="/cronograma" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<CronogramaPeriodos />} />} />
            {/* <Route path="/auditoria" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<AuditoriaCompleta />} />} /> */}
            <Route path="/publicaciones" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<Publicaciones />} />} />
            <Route path="/horario-estudiante" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<HorarioEstudianteAdmin />} />} />
            <Route path="/expulsacion" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<ModuloExpulsiones />} />} />
            <Route path="/manual" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<ManualAdmin />} />} />
            <Route path="/director-de-grupo" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<DirectorGrupo />} />} />
            <Route path="/comportamiento" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<ModuloComportamiento />} />} />
            <Route path="/sede" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<Sedes />} />} />
            <Route path="/horas-social" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<HorasSocialesRector />} />} />
            <Route path="/boletines-masivo" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<BoletinesMasivo />} />} />
            <Route path="/subir-logo" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<LogosInstituciones />} />} />
            <Route path="/elecciones-rector" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<EleccionesRector />} />} />
            <Route path="/resultados-eleccion" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<ResultadosEleccion />} />} />
            <Route path="/informes-rector" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<InformesRector />} />} />
            <Route path="/ficha-seguimiento-revision" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<FichaSeguimientoRevision />} />} />
            <Route path="/elecciones" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorEleccionesPro />} />} />
         <Route path= "/auditoria" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<Auditoria />} />} />
         <Route path="/foto-perfil-estudiante/:id" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<FotoPerfilEstudiante />} />} />
         <Route path="/hoja-vida-estudiante/:id" element={<PrivateRoute allowedRoles={["rector", "coordinador", "profesor"]} element={<HojaVidaEstudiante />} />} />
          <Route path="/simulacro-rectoria" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorSimulacros />} />} />
            <Route path= "/analitica-simulacro-rector" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorAnaliticaSimulacro />} />} />
            <Route path="/planeaciones-rector" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<RectorPlaneaciones />} />} />
            <Route path="/matricula-masiva" element={<PrivateRoute allowedRoles={["rector", "coordinador","secretaria"]} element={<MatriculaMasiva />} />} />
            <Route path="/autoevaluacion-gestion" element={<PrivateRoute allowedRoles={["rector", "coordinador"]} element={<AutoevaluacionGestion />} />} />
            
            {/* ================== ESTUDIANTE ================== */}
            <Route
              path="/perfil-estudiante"
              element={<PrivateRoute allowedRoles={["estudiante"]} element={<PerfilEstudiante />} />}
            />
            <Route
              path="/perfil-estudiante/:id"
              element={<PrivateRoute allowedRoles={["estudiante"]} element={<PerfilEstudiante />} />}
            />
            <Route
              path="/tareas-estudiante"
              element={<PrivateRoute allowedRoles={["estudiante"]} element={<TareasEstudiante />} />}
            />
            <Route
              path="/mis-asignaciones-estudiante"
              element={<PrivateRoute allowedRoles={["estudiante"]} element={<MisAsignacione />} />}
            />
            <Route
              path="/mis-calificaciones"
              element={<PrivateRoute allowedRoles={["estudiante"]} element={<MisNotasEstudiante />} />}
            />
            <Route
              path="/excusas-estudiante"
              element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<ExcusaForm user={user} />} />}
            />
            <Route
              path="/ver-contenido/:asignaturaId"
              element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<VerContenido />} />}
            />
            <Route
              path="/horario-student"
              element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<HorarioEstudiante />} />}
            />

   <Route
              path="/guias"
              element={<PrivateRoute allowedRoles={["estudiante", "padre"]} element={<ContenidosEstudiante />} />}
            />

 <Route path="/manual-convivencia-estudiante" element={<PrivateRoute allowedRoles={["estudiante"]} element={<ManualViewer />} />} />

<Route
  path="/horas-sociales"
  element={
    <PrivateRoute
      allowedRoles={["estudiante"]}
      element={<HorasSocialesEstudiante />}
    />
  }
/>


<Route
  path="/elecciones-estudiante"
  element={
    <PrivateRoute
      allowedRoles={["estudiante"]}
      element={<EleccionesEstudiante />}
    />
  }
/>

<Route
  path="/dasboard-estudiante"
  element={
    <PrivateRoute
      allowedRoles={["estudiante"]}
      element={<DashboardEstudiante />}
    />
  }
/>


<Route
  path="/simulacros-estudiante"
  element={
    <PrivateRoute
      allowedRoles={["estudiante"]}
      element={<EstudianteSimulacros />}
    />
  }
/>


  <Route path="/my-boletin" element={<PrivateRoute allowedRoles={["estudiante"]} element={<MiBoletin />} />} />

            {/* ================== PADRE ================== */}
            <Route
              path="/perfil-padre/:id"
              element={<PrivateRoute allowedRoles={["padre"]} element={<PadrePerfil />} />}
            />

                 <Route
              path="/dashboard-padre"
              element={<PrivateRoute allowedRoles={["padre"]} element={<DashboardPadre />} />}
            />
            <Route
              path="/tareas-padre"
              element={<PrivateRoute allowedRoles={["padre"]} element={<TareasPadre />} />}
            />

       
            <Route
              path="/rendimiento-padre/:estudianteId"
              element={<PrivateRoute allowedRoles={["padre"]} element={<PadreRendimiento />} />}
            />
               <Route
              path="/excusas-padre/:estudianteId"
              element={<PrivateRoute allowedRoles={["padre"]} element={<PadreExcusas />} />}
            />
                     <Route
              path="/notas-padre/:estudianteId"
              element={<PrivateRoute allowedRoles={["padre"]} element={<PadreNotas />} />}
            />

   
                             <Route
              path="/asistencia-padre/:estudianteId"
              element={<PrivateRoute allowedRoles={["padre"]} element={<PadreAsistencia />} />}
            />

                                       <Route
              path="/boletin-padre"
              element={<PrivateRoute allowedRoles={["padre"]} element={<BoletinPadre />} />}
            />

       



            {/* ================== PROFESOR ================== */}
            <Route
              path="/perfil-profesor/:id"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<ProfesorPerfil />} />}
            />
            <Route
              path="/mis-asignaciones-profesor"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<MisAsignaciones />} />}
            />
            <Route
              path="/lista-estudiantes"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<ListaEstudiantes />} />}
            />
            <Route
              path="/tareas-profesor"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<TareasProfesor />} />}
            />
            <Route
              path="/evaluaciones-clase"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<EvaluacionesClase />} />}
            />
            <Route
              path="/asistencias-profesor"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<AsistenciaProfesor />} />}
            />
            <Route
              path="/excusas-profesor"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<ExcusasProfesor user={user?.id} />} />}
            />
            <Route
              path="/mi-horario"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<HorarioProfesor profesorId={user?.id} />} />}
            />
            <Route
              path="/notas"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<CalificacionesProfesor profesorId={user?.id} />} />}
            />
            <Route
              path="/planeacion/:asignaturaId"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloPlaneacionWrapper />} />}
            />
            <Route
              path="/gestion-contenido/:asignaturaId"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<GestionContenidoWrapper />} />}
            />
            <Route
              path="/dashboard-profesor"
              element={<PrivateRoute allowedRoles={["profesor"]} element={<DashboardProfesor />} />}
            />
        <Route path="/notas-finales" element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloNotasFinales profesor_id={user?.id} />
} />} />
            <Route path="/manual-convivencia-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<ManualViewer />} />} />
             <Route path="/direccion-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<DirectorGrupoProfesor />} />} />
      {/* <Route path="/diciplina" element={<PrivateRoute allowedRoles={["profesor"]} element={<ModuloDisciplina />} />} /> */}
           <Route path="/horas-sociales-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<HorasSocialesProfesor />} />} />
            <Route path="/boletin" element={<PrivateRoute allowedRoles={["profesor"]} element={<BoletinesProfesor />} />} />

            <Route path="/recuperaciones-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<ProfesorRecuperaciones />} />} />

                <Route path="/pendientes" element={<PrivateRoute allowedRoles={["profesor"]} element={<PendientesDocente />} />} />
                  <Route path="/observaciones" element={<PrivateRoute allowedRoles={["profesor"]} element={<Observaciones />} />} />
                   <Route path="/ficha-seguimiento" element={<PrivateRoute allowedRoles={["profesor"]} element={<FichaSeguimiento />} />} />
                    <Route path="/boletin-profesor" element={<PrivateRoute allowedRoles={["profesor"]} element={<BoletinProfesor />} />} />
                     <Route
  path="/foto-perfil-estudiante"
  element={
    <PrivateRoute
      allowedRoles={["profesor", "coordinador", "secretaria", "rector"]}
      element={<FotoPerfilEstudiante />} />  }/>

<Route
  path="/hoja-vida-estudiante/profesor"
  element={
    <PrivateRoute
      allowedRoles={["profesor"]}
      element={<HojaVidaEstudianteProfesor />} />  }/>

      <Route
  path="/simulacros-profesor"
  element={
    <PrivateRoute
      allowedRoles={["profesor"]}
      element={<ProfesorSimulacros />} />  }/>

      <Route
  path="/votacion"
  element={
    <PrivateRoute
      allowedRoles={["estudiante", "profesor"]}
      element={<EleccionesVotacion />}
    />
  }
/>

    <Route
  path="/planeaciones"
  element={
    <PrivateRoute
      allowedRoles={["estudiante", "profesor"]}
      element={<ProfesorPlaneaciones />} />


  }
/>

<Route path="/autoevaluacion-responder/:id" element={<PrivateRoute allowedRoles={["estudiante", "profesor", "rector", "coordinador", "desarrollador","secretaria","padre"]} element={<AutoevaluacionResponder />} />} />


           {/* desarrollador */}

              {/* ================== DESARROLLADOR ================== */}
<Route
  path="/crear-institucion"
  element={
    <PrivateRoute
      allowedRoles={["desarrollador"]}
      element={<CrearInstitucion />}
    />
  }
/>
<Route
  path="/dev-dashboard"
  element={
    <PrivateRoute
      allowedRoles={["desarrollador"]}
      element={<DevDashboard />}
    />
  }
/>


{/* secretaria */}

<Route
  path="/dashboard-secretaria"
  element={
    <PrivateRoute
      allowedRoles={["secretaria"]}
      element={<DashboardSecretaria />}
    />
  }
/>

<Route
  path="/secretaria/estudiantes"
  element={
    <PrivateRoute
      allowedRoles={["secretaria", "rector", "coordinador"]}
      element={<SecretariaBuscarEstudiantes />}
    />
  }
/>

<Route path="/secretaria/certificaciones" element={<Certificados />} />



<Route path="/matriculasecretaria" element={<MatriculaForm />} />
<Route path="/informes" element={<Informes />} />
<Route path="/documentos" element={<GestionDocumentos/>} />



          </Routes>
        </div>
      </div>
    </>
  );
}

export default function App() {
  return <AppContent />;
}
